import type { FC } from 'react';
import React from 'react';

import { GlobalStyle } from '@theme/GlobalStyle';
import { DPThemeProvider } from '@theme/DPThemeProvider';
import type { Document } from '@models/Document';
import type { LayoutProps } from '@layout/index';
import { Navigation } from '@layout/components/Navigation/Navigation';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { PageWrapper } from './components/PageWrapper/PageWrapper';

export type ErrorLayoutProps = {
  showNav: boolean;
} & LayoutProps &
  Document;

export const Error: FC<ErrorLayoutProps> = (props) => {
  const headerPublicRuntimeSettings = {
    epicServiceClientId: props.publicRuntimeSettings.epicServiceClientId,
    epicAccountPortalBaseUrl: props.publicRuntimeSettings.epicAccountPortalBaseUrl,
    epicAccountPortalBasePath: props.publicRuntimeSettings.epicAccountPortalBasePath,
  };

  return (
    <DPThemeProvider>
      <GlobalStyle />
      <PageWrapper>
        <Header {...props.i18nContext} publicRuntimeSettings={headerPublicRuntimeSettings} />
        <div className="container">
          {props?.showNav && (
            <Navigation navTree={props.navTree} activeDocMeta={props.activeDocMeta} {...props.i18nContext} />
          )}
          <section className="page">
            {props.children}
            <Footer locale={props.i18nContext.locale} />
          </section>
        </div>
      </PageWrapper>
    </DPThemeProvider>
  );
};
